import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=b67aab64&scoped=true"
import script from "./search-input.vue?vue&type=script&lang=js"
export * from "./search-input.vue?vue&type=script&lang=js"
import style0 from "./search-input.vue?vue&type=style&index=0&id=b67aab64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67aab64",
  null
  
)

export default component.exports